import {
  Component,
  AfterViewInit,
  ViewChild,
  ElementRef,
  HostListener,
} from "@angular/core";
import grapesjs from "grapesjs";
import type { Component as GjsComponent } from "grapesjs";
import presetNewsletter from "grapesjs-preset-newsletter";
import blocksBasic from "grapesjs-blocks-basic";
import { EmailBuilderService } from "src/app/services/emailbuilder/emailbuilder.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { ClientService } from "src/app/services/clients/client.service";
import { Subscription } from "rxjs";
import {
  CbEmailTableStateService,
  UsersFilters,
} from "../cb-email-templates/cb-email-table.service";
import { pairwise, take } from "rxjs/operators";
import { TableState } from "src/app/services/base-table-state.service";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { MasterService } from "src/app/services/master/master.service";
import html2canvas from 'html2canvas';
import { CampaignBuilderService } from "src/app/services/segmentation/campaign-builder.service";
import { WorkingCompanyService } from 'src/app/services/working-company/working-company.service';
export type PreviewSource = 'theme' | 'upload' | 'generate';

@Component({
  selector: "app-cb-email-builder",
  // standalone: true,
  // imports: [],
  templateUrl: "./cb-email-builder.component.html",
  styleUrls: ["./cb-email-builder.component.scss"],
})
export class CBEmailBuilderComponent {
  @ViewChild("editorWrapper", { static: true }) editorRef!: ElementRef;
  @ViewChild("themeDropdown") themeDropdown!: ElementRef;
  @ViewChild('previewField') previewField!: ElementRef;

  private modalRef!: NgbModalRef;

  editor: any;
  currentUser: any;
  apiAssetsLoaded: boolean = false;
  editTemplateId: number | null = null;
  editTemplateData: any;
  isEdit: boolean = false;
  templateName: string = "";
  templateForm: FormGroup;
  submitted: boolean = false;
  getCompanyobj: any = [];
  companyID: number | null = null;
  domainID: number | null = null;
  limit: number = 14;
  page: number = 0;
  totalAssets = 0;
  journeyTypeObj = [];
  domainData = [];
  themeObj = [];
  themeIds: number[] = [];
  isThemeDropActive = false;
  themeItems: any = [];
  filteredThemeItems: any[] = [];
  searchText: string = "";
  selectedThemeItem: string | null = null;
  private sub = new Subscription();
  selectedFileName: string | null = null;
  imagePreview: string | null = null;
  personalizationData: { [key: string]: any[] } = {};
  private savedRange: Range | null = null;

  imageSearchText: string = "";
  searchDebounceTimer: any;
  domainCurrentValue:number | string = "null";
  emailTemplateThemeCategoryId: number | null = null;
  isDomainChanged: boolean = false;
  thumbnailUrl: string | null = null;

  aiInputValue: string = '';
  aiIsStreaming: boolean = false;
  aiIsFetchingSuggestions: boolean = false;
  aiSuggestedTemplates: any[] = [];
  aiLastPrompt: string = '';

  promptSnippetsData: any[] = [];
  promptSnippetsFetched: boolean = false;
  promptSnippetsPage: number = 1;
  promptSnippetsLimit: number = 20;
  promptSnippetsTotal: number = 0;
  promptSnippetsLoadingMore: boolean = false;

  previewSource: PreviewSource = 'theme';
  popoverOpen = false;

  selectedFile: File | null = null;

  selectedThemeImageUrl: string | null = null;
  selectedThemeName: string = '';
  generatedPreviewUrl: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private eb: EmailBuilderService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private clientService: ClientService,
    private master: MasterService,
    private tableState: CbEmailTableStateService,
    private modalService: NgbModal,
    private elRef: ElementRef,
    private campaignBuilderService: CampaignBuilderService,
    private workingCompany: WorkingCompanyService
  ) {
    this.templateForm = this.fb.group({
      templateName: ["", [Validators.required, Validators.maxLength(100)]],
      company: ["", Validators.required],
      domainName: [""],
      journeyType: [""],
      templateSubject: ["", Validators.required],
      themeId: [],
    });
  }

  toggleDropdown(event: Event) {
    event.stopPropagation(); // 🔥 IMPORTANT
    this.isThemeDropActive = !this.isThemeDropActive;
  }

  goBackToTemplateList() {
    this.router.navigate(["/corporate/cb-email-templates"]);
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: Event) {
    if (
      this.isThemeDropActive &&
      this.themeDropdown &&
      !this.themeDropdown.nativeElement.contains(event.target)
    ) {
      this.isThemeDropActive = false;
    }

    if (
      this.popoverOpen &&
      this.previewField &&
      !this.previewField.nativeElement.contains(event.target)
    ) {
      this.popoverOpen = false;
    }
  }
  getBusinessDomain() {
    let self = this;
    this.master.getBusinessDomain(100, 0, this.companyID).subscribe(
      (data) => {
        self.domainData = data.data.rows;
      },
      (error) => {
        console.log(error);
      },
    );
  }
  async ngOnInit() {
    await this.getCompany();

    this.editTemplateId = Number(this.route.snapshot.queryParamMap.get("id"));
    this.companyID = Number(this.route.snapshot.queryParamMap.get("cid"));
    this.currentUser = JSON.parse(sessionStorage.getItem("userData")!);

    // when arriving with a company id in create mode, preselect and load domains
    if (!this.editTemplateId && this.companyID) {
      // this.templateForm.patchValue({ company: this.companyID });
      this.onCompanyChangeGetJourney(this.companyID);

      // this.tableState.updateFilters({
      //   companyID: this.companyID,
      //   journeyID: null,
      //   themesID: [],
      //   domainID: null,
      // });
    }

    // ---------- EDIT MODE ----------
    if (this.editTemplateId && this.companyID) {
      const res = await this.getTemplateById(
        this.companyID,
        this.editTemplateId,
      );

      if (res) {
        setTimeout(() => this.InitTemplateBuilder(), 0);
        this.initPersonalizedFields();
      }
    }
    // ---------- CREATE MODE ----------
    else {
      this.sub.add(
        this.tableState.state$
          .pipe(take(1))
          .subscribe((state) => this.handleInitialLoad(state)),
      );
    }

    // ---------- COMPANY CHANGE ----------
    this.templateForm.get("company")?.valueChanges.subscribe((value) => {
      this.companyID = value;

      if (this.companyID && this.companyID !== 0) {
        if (!this.editor) {
          setTimeout(() => this.InitTemplateBuilder(), 0);
        }
        this.initPersonalizedFields();
        this.onCompanyChangeGetJourney(value);
        this.getBusinessDomain();
      } else {
        this.editor?.destroy();
        this.editor = null;
      }

      this.templateForm.patchValue({
        journeyType: "",
        themeId: [],
      });
      this.tableState.updateFilters({
        companyID: Number(this.companyID),
        journeyID: null,
        themesID: [],
        // clear domain when company switches so stale value isn’t kept
        domainID: null,
      });
      this.selectedThemeItem = "";
    });

    // ---------- JOURNEY CHANGE ----------
    this.templateForm.get("journeyType")?.valueChanges.subscribe((value) => {
      if (value) {
        this.onJourneyTypeChangeGetTheme(value);
        this.templateForm.patchValue({
          themeId: [],
        });
        this.tableState.updateFilters({
          journeyID: Number(value),
          themesID: [],
        });
        this.selectedThemeItem = "";
      }
    });
    // ---------- DOMAIN CHANGE ----------
    this.templateForm.get("domainName")?.valueChanges.subscribe((value) => {
      this.domainID = value;
      if (value) {
        this.tableState.updateFilters({ domainID: value });
      }
      this.isDomainChanged = true;
      this.domainCurrentValue = value;
    });

    this.filteredThemeItems = [...this.themeItems];
  }

  private async handleInitialLoad(state: TableState<UsersFilters>) {
    if (this.isDefaultFilters(state.filters)) {
      return;
    }
    const filters = state.filters;

    if (filters.companyID) {
      this.templateForm.patchValue({
        company: filters.companyID,
        journeyType: filters.journeyID ? filters.journeyID : "",
        domainName: filters.domainID ? filters.domainID : "",
        themeId: filters.themesID.length > 0 ? filters.themesID : [],
      });
      this.companyID = filters.companyID;
      if (filters.domainID) {
        this.domainID = filters.domainID;
      }
      this.initPersonalizedFields();
      this.getBusinessDomain();

      if (!this.editor) {
        setTimeout(() => this.InitTemplateBuilder(), 0);
      }
      this.onCompanyChangeGetJourney(filters.companyID);
    }
    if (filters.journeyID) {
      await this.onJourneyTypeChangeGetTheme(filters.journeyID);
      if (filters.themesID.length > 0) {
        let theme_names = filters.themesID
          .map(
            (id) =>
              this.themeItems.find((obj: any) => obj.theme_id === id)
                ?.theme_name,
          )
          .filter((name) => name)
          .join(", ");
        this.selectThemeItem({
          theme_id: filters.themesID,
          theme_name: theme_names,
        });
      }
    }
  }

  private isDefaultFilters(filters: UsersFilters): boolean {
    return (
      filters.companyID === null &&
      filters.journeyID === null &&
      filters.themesID.length === 0
    );
  }

  async InitTemplateBuilder() {
    this.editor = grapesjs.init({
      container: this.editorRef.nativeElement,
      fromElement: false,
      height: "700px",
      width: "auto",
      colorPicker: {
        appendTo: 'body', 
      },
      storageManager: {
        type: "local", // or 'remote' for API
        autosave: true,
        autoload: true,
        stepsBeforeSave: 1,
      },
      assetManager: {
        upload: false, // IMPORTANT: disable default upload
        custom: true,
        uploadFile: (e: any) => {
          const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;

          this.uploadImagesToServer(files, this.editor);
        },
      },
      plugins: [presetNewsletter, blocksBasic],
      pluginsOpts: {
        "gjs-preset-newsletter": {
          blocks: [
            "sect100",
            "sect50",
            "sect30",
            "button",
            "divider",
            "text",
            "image",
            "link",
          ],
          blockLabel: "Email Elements",
        },
        "gjs-blocks-basic": {
          flexGrid: false,
        },
      },
      panels: {
        defaults: [
          {
            id: "commands",
            buttons: [
              {
                id: "undo",
                className: "fa fa-undo",
                command: "core:undo",
                attributes: { title: "Undo" },
              },
              {
                id: "redo",
                className: "fa fa-repeat",
                command: "core:redo",
                attributes: { title: "Redo" },
              },
              {
                id: "export",
                className: "fa fa-code",
                command: "export-template",
                attributes: { title: "Export HTML" },
              },
            ],
          },
        ],
      },
    });

    const iframe = this.editor.Canvas.getFrameEl();
    const iframeDoc = iframe.contentDocument;
    const el = iframeDoc.querySelectorAll('.container');
    el.forEach(element => {
      element.style.width = '100%';
    });
    this.editor.Components.addType("cell", {
      extend: "cell", // important
      model: {
        defaults: {
          editable: true,
          type: "text",
        },
      },
    });

    this.editor.on("load", () => {
      setTimeout(() => {
        const cells = this.editor.getWrapper().find("td");
        cells.forEach((cell: any) => {
          cell.set({
            editable: true,
          });
        });
      }, 200);
    });

    this.editor.on("component:add", (component: any) => {
      if (component.is("image")) {
        console.log("Image added:", component.get("src"));
      }
    });

    this.editor.on("asset:open", () => {
      const modal = this.editor.Modal.getContentEl();
      modal.innerHTML = ""; // 🔴 clear default UI

      if (!this.apiAssetsLoaded || this.isDomainChanged) {
        this.loadImagesFromServer(0);

        this.apiAssetsLoaded = true;
        this.isDomainChanged = false;
      }

      const wrapper = document.createElement("div");
      wrapper.className = "custom-asset-manager";

      wrapper.innerHTML = `
      <div class="am-left">
        <div class="upload-box" id="uploadBox">
          <p>Drop files here or click to upload</p>
          <input type="file" id="uploadInput" accept="image/*" multiple hidden />
        </div>
        <div id="fileMaxChar" class="alert alert-danger d-none" role="alert">
          File name cannot exceed 50 characters.
        </div>
        
      </div>

      <div class="am-right">
          <div class="row">
            <div class="col-md-7 mb-1 pr-0">
              <input type="text" style="width: 100%" id="assetSearch" placeholder="Search images..." />
            </div>
            <div class="journey-selectbox col-md-3 mb-1 pr-0">
              <select id="domainSelect" class="custom-select border-trns" style="height: 100%;" placeholder="Select Domain">
                <option value="null" selected>All</option>
              </select>
            </div>
            <div class="journey-selectbox col-md-2 mb-1 pr-0">
              <button id="resetBtn" class="custbtn">Reset</button>
            </div>
          </div>

        <div class="asset-list" id="assetList"></div>

        <div id="noAssetsMessage"></div>

        <div class="asset-pagination">
          <button id="prev">Prev</button>
          <div id="pageNumbers" class="page-numbers"></div>
          <button id="next">Next</button>
        </div>
      </div>
    `;

      modal.appendChild(wrapper);

      this.bindAssetUIEvents();
      this.renderAssetList();
      this.updatePaginationButtons();
    });

    this.editor.on("asset:remove", (asset: any) => {
      this.showConfirmPopup(
        "Are you sure you want to delete this image? This action cannot be undone.",
        () => {
          this.deleteImageFromServer(asset?.attributes?.id);
        }
      );
    });

    this.editor.once("load", async () => {
      const bm = this.editor.BlockManager;

      const blockCategoryMap: any = {
        sect100: {
          id: "layout",
          label: "Layouts",
          open: true,
        },
        sect50: {
          id: "layout",
          label: "Layouts",
          open: true,
        },
        sect30: {
          id: "layout",
          label: "Layouts",
          open: true,
        },
        text: {
          id: "content",
          label: "Content",
          open: true,
        },
        image: {
          id: "media",
          label: "Media",
          open: true,
        },
        link: {
          id: "content",
          label: "Content",
          open: true,
        },
        button: {
          id: "actions",
          label: "Actions",
          open: true,
        },
        divider: {
          id: "layout",
          label: "Layouts",
          open: true,
        },
        // Add more mappings as needed
      };

      bm.getAll().forEach((block: any) => {
        const id = block.get("id");

        const currentCat = block.get("category");
        const cat = blockCategoryMap[id];

        if (cat && (!currentCat || typeof currentCat === "string")) {
          block.set("category", cat);
        } else if (!currentCat) {
          block.set("category", {
            id: "misc",
            label: "Miscellaneous",
            open: true,
          });
        }
      });

      this.editor.Blocks.render();

      const blocksEl = this.editor.BlockManager.render();

      if (blocksEl) {
        const searchEl = document.createElement("input");
        searchEl.type = "text";
        searchEl.placeholder = "Search...";
        searchEl.className = "gjs-block-search";
        searchEl.style.width = "88%";
        searchEl.style.padding = "5px";
        searchEl.style.marginTop = "10px";

        blocksEl.parentElement?.insertBefore(searchEl, blocksEl);

        searchEl.addEventListener("input", () => {
          const searchTerm = searchEl.value.toLowerCase();
          const allBlocks = blocksEl.querySelectorAll(".gjs-block");

          allBlocks.forEach((block: Element) => {
            const content = block.textContent?.toLowerCase() || "";
            (block as HTMLElement).style.display = content.includes(searchTerm)
              ? ""
              : "none";
          });
        });
      }

      if (this.editTemplateId) {
        this.editor.setComponents(this.editTemplateData.template_html);
      }
    });

    this.editor.Panels.addButton("options", {
      id: "open-code",
      className: "fa fa-code",
      command: "open-editable-code",
      attributes: { title: "Edit Code (HTML & CSS)" },
    });

    this.editor.Panels.addButton("options", {
      id: "open-code",
      className: "fa fa-lightbulb-o",
      command: "open-ai-agent",
      attributes: { title: "Generate Template with marGo AI Agent" },
    });

    this.loadHtmlEditor();
    this.openMargoAITemplateCreationModel();

    (window as any).editor = this.editor;

    this.registerMergeTagRTE();
  }

  

  onSearchChange() {
    const search = this.searchText?.toLowerCase().trim() || "";

    // 🔥 If search empty → show all
    if (!search) {
      this.filteredThemeItems = [...this.themeItems];
      return;
    }

    // 🔥 Filter by name
    this.filteredThemeItems = this.themeItems.filter((item: any) =>
      item.theme_name.toLowerCase().includes(search),
    );
  }

  selectThemeItem(
    item: { theme_id: number[]; theme_name: string },
    source?: any,
  ) {
    this.selectedThemeItem = item.theme_name;
    this.searchText = "";
    this.isThemeDropActive = false;
    this.templateForm.patchValue({
      themeId: Array.isArray(item.theme_id) ? item.theme_id : [item.theme_id],
    });

    if (source === "dropdownClick")
      this.tableState.updateFilters({
        themesID: Array.isArray(item.theme_id)
          ? item.theme_id
          : [item.theme_id],
      });

    // optional: mark as touched for validation
    this.templateForm.get("themeId")?.markAsTouched();
  }

  renderAssetList(filter: string = "") {
    const list = document.getElementById("assetList");
    const existingMsg: any = document.getElementById("noAssetsMessage");
    if (!list) return;

    list.innerHTML = "";

    const assets = this.editor.AssetManager.getAll().filter((asset: any) =>
      asset.get("name")?.toLowerCase().includes(filter.toLowerCase()),
    );

    // If no assets → show empty message
    if (!assets || assets.length === 0) {
      const emptyMsg = document.createElement("div");
      emptyMsg.className = "no-assets";
      emptyMsg.innerText = "No record found";
      existingMsg.innerHTML = ""; // clear previous message
      existingMsg.appendChild(emptyMsg);
      return; // stop further execution
    }

    existingMsg.innerHTML = ""; // clear message if assets exist

    assets.forEach((asset: any) => {
      const item = document.createElement("div");
      item.className = "asset-item";

      item.innerHTML = `
        <div class="asset-item-content"><img src="${asset.get(
          "src",
        )}" data-asset-id="${asset?.attributes?.id}" />
        <span>${asset.get("name") || "Image"}</span></div>
        <button class="delete">✕</button>
      `;

      // select image
      item
        .querySelector(".asset-item-content")!
        .addEventListener("click", () => {
          const src = asset.get("src");
          const editor = this.editor;

          // Insert into selected component or canvas
          const selected = editor.getSelected();
       
          if (selected && selected.is("image")) {
            // Replace existing image
            selected.set("src", src);
          } else if (selected) {
            // Append image inside selected component
            editor.append({
              type: "image",
              src,
              attributes: {
                "data-asset-id": asset.assetId,
              },
            });
          } else {
            // Add image to canvas
            editor.addComponents({
              type: "image",
              src,
              attributes: {
                "data-asset-id": asset.assetId,
              },
            });
          }

          // Close modal (optional)
          editor.Modal.close();
        });

      // delete image
      item.querySelector(".delete")!.addEventListener("click", (e) => {
        e.stopPropagation();
        this.editor.AssetManager.remove(asset);
        this.renderAssetList();
      });

      list.appendChild(item);
    });
    this.renderNumberPagination();
  }

  bindAssetUIEvents() {
    this.imageSearchText = "";
    const uploadBox = document.getElementById("uploadBox");
    const fileMaxChar = document.getElementById("fileMaxChar");
    const uploadInput = document.getElementById(
      "uploadInput",
    ) as HTMLInputElement;
    const search = document.getElementById("assetSearch") as HTMLInputElement;

    // Upload click
    uploadBox?.addEventListener("click", () => uploadInput.click());

    // Upload file (FE example)
    uploadInput?.addEventListener("change", () => {
      if (this.domainCurrentValue == "null" && !this.editTemplateId){
        this.toastrService.warning(
          "Please select a domain before uploading an image.",
        );
        return;
      }

      const file = uploadInput.files;
      if (!file) return;
      const fileName = file[0].name;
      const nameWithoutExt =
        fileName.substring(0, fileName.lastIndexOf(".")) || fileName;
      if (nameWithoutExt.length > 50) {
        fileMaxChar.classList.remove("d-none");
        // alert("File name cannot exceed 50 characters.");
        uploadInput.value = ""; // reset input
        return;
      }

      if (file.length > 5) {
        this.toastrService.warning(
          "Maximum 5 images can be uploaded at a time.",
        );
        return;
      }
      fileMaxChar.classList.add("d-none");
      this.uploadImagesToServer(file, this.editor);
    });

    // Search
    search?.addEventListener("input", () => {
      clearTimeout(this.searchDebounceTimer);

      this.searchDebounceTimer = setTimeout(() => {
        this.imageSearchText = search.value;
        this.page = 0;
        this.loadImagesFromServer(this.page);
      }, 400);
    });

    // Domain Filter
    const domainSelect = document.getElementById("domainSelect") as HTMLSelectElement;
    
    if (domainSelect && this.domainData?.length) {
      this.domainData.forEach((domain: any) => {
        const option = document.createElement("option");
        option.value = domain.id;
        option.textContent = domain.domain_name;
          if (domain.id == this.domainCurrentValue) {
            option.selected = true;
          }
        domainSelect.appendChild(option);
      });
    }

    // Reset Filter Button
    const resetBtn = document.getElementById("resetBtn") as HTMLButtonElement;

    resetBtn?.addEventListener("click", (e: any) => {
      // Search reset
      const search = document.getElementById("assetSearch") as HTMLInputElement;
      search.value = "";
      this.imageSearchText = "";

      // Domain reset
      const domainSelect = document.getElementById("domainSelect") as HTMLSelectElement;
      domainSelect.value = "null"; // default option value

      this.domainCurrentValue = "null";

      // Pagination reset
      this.page = 0;

      // Reload data
      this.loadImagesFromServer(this.page);
    })

    domainSelect?.addEventListener("change", (e: any) => {
      this.domainCurrentValue = e.target.value;
      // optional: reload images
      this.page = 0;
      this.loadImagesFromServer(this.page);
    });

    // Pagination
    document.getElementById("prev")?.addEventListener("click", () => {
      this.page = this.page <= 0 ? 0 : this.page - this.limit;
      this.loadImagesFromServer(this.page);
    });

    document.getElementById("next")?.addEventListener("click", () => {
      this.page = this.page + this.limit;
      this.loadImagesFromServer(this.page);
    });
  }

  updatePaginationButtons() {
    const prevBtn = document.getElementById("prev") as HTMLButtonElement;
    const nextBtn = document.getElementById("next") as HTMLButtonElement;

    if (!prevBtn || !nextBtn) return;

    prevBtn.disabled = this.page <= 0;
    nextBtn.disabled = this.page + this.limit >= this.totalAssets;

    // Optional visual feedback
    prevBtn.style.opacity = prevBtn.disabled ? "0.5" : "1";
    nextBtn.style.opacity = nextBtn.disabled ? "0.5" : "1";
  }

  renderNumberPagination() {
    const container = document.getElementById("pageNumbers");
    if (!container) return;

    container.innerHTML = "";

    const totalPages = Math.ceil(this.totalAssets / this.limit);
    const currentPage = Math.floor(this.page / this.limit);

    const createBtn = (i: number) => {
      const btn = document.createElement("button");
      btn.innerText = (i + 1).toString();

      if (i === currentPage) {
        btn.classList.add("active");
      }

      btn.addEventListener("click", () => {
        this.page = i * this.limit;
        this.loadImagesFromServer(this.page);
      });

      return btn;
    };

    const createDots = () => {
      const span = document.createElement("span");
      span.innerText = "...";
      span.style.color = "#636363";
      span.style.fontWeight = "bold";
      span.classList.add("dots");
      return span;
    };

    if (totalPages <= 1) return;

    // Always first page
    container.appendChild(createBtn(0));

    const start = Math.max(1, currentPage - 2);
    const end = Math.min(totalPages - 2, currentPage + 2);

    // Left dots ONLY if gap exists
    if (start > 1) {
      container.appendChild(createDots());
    }

    // Middle pages
    for (let i = start; i <= end; i++) {
      container.appendChild(createBtn(i));
    }

    // Right dots ONLY if gap exists
    if (end < totalPages - 2) {
      container.appendChild(createDots());
    }

    // Always last page
    container.appendChild(createBtn(totalPages - 1));
  }

  ngOnDestroy(): void {
    if (this.editor) {
      this.editor.runCommand("core:canvas-clear");
      // Optional: clear assets manually
      this.editor.AssetManager.getAll().reset();
    }
    this.sub.unsubscribe();
  }

  async getCompany() {
    let self = this;
    const data = await this.clientService.getBUCompanies().toPromise();
    try {
      self.getCompanyobj = data.data;
      self.workingCompany.applyToHost(self);

      this.getCompanyobj = this.getCompanyobj.sort((a: any, b: any) => {
        return a.customer_company_name.localeCompare(b.customer_company_name);
      });
      // if (!this.editTemplateId) {
      //   this.templateForm.patchValue({
      //     company: self.getCompanyobj[0].customer_id,
      //   });
      // }
    } catch (err) {
      throw err;
    }
  }

  async getTemplateById(companyID: number, template_id: number): Promise<any> {
    this.spinner.show();
    try {
      const res = await this.eb
        .getEmailTemplateById(companyID, template_id)
        .toPromise();
      this.spinner.hide();
      if (res.status) {
        this.editTemplateData = res.data;
        if(res.data?.image_source == "template"){
          this.selectedFileName = this.getFileNameFromUrl(
            res.data?.template_image,
          );
          this.imagePreview = res.data?.template_image;
        }
        this.domainCurrentValue = this.editTemplateData.theme_category_id;
        this.emailTemplateThemeCategoryId = this.editTemplateData.theme_category_id;

        if(res.data?.image_source == "preview"){ // (Generate from template)
          this.previewSource = 'generate';
        }else if(res.data?.image_source == "template"){ // (Custom Image)
          this.previewSource = 'upload';
        }else{ // (Use Theme Image)
          this.previewSource = 'theme';
        }
        // console.log("res.data", res.data);
        this.onCompanyChangeGetJourney(res.data.company_id);
        this.getBusinessDomain();

        await this.onJourneyTypeChangeGetTheme(Number(res.data.journey_id));
        this.selectThemeItem({
          theme_id: this.convertToArray(this.editTemplateData.theme_ids),
          theme_name: res.data.theme_names,
        });
        this.templateForm.patchValue({
          templateName: this.editTemplateData.template_name,
          company: this.editTemplateData.company_id,
          journeyType: this.editTemplateData.journey_id,
          templateSubject: this.editTemplateData.template_subject,
          themeId: this.convertToArray(this.editTemplateData.theme_ids),
          domainName: this.editTemplateData.business_domain_id
            ? this.editTemplateData.business_domain_id
            : "",
        });

        if(this.selectedFileName && res.data?.image_source == "template"){
          await this.convertUrlToBase64(this.imagePreview, this.selectedFileName);
        }
        return res.data;
      }
    } catch (err) {
      this.spinner.hide();
      this.toastrService.error("Something went wrong while fetching template.");
      throw err;
    }
  }

  submit() {
    this.submitted = true;
    if (this.templateForm.valid) {
      this.templateForm.markAllAsTouched();
      // console.log(
      //   "this.templateForm.getRawValue()",
      //   this.templateForm.getRawValue(),
      // );

      this.saveTemplate();
    }
  }

  convertToArray(value: any): number[] {
    if (!value) return [];

    return String(value)
      .split(",")
      .map((v) => Number(v.trim()))
      .filter((v) => !isNaN(v));
  }

  async generateThumbnail(): Promise<string> {
    const canvasBody = this.editor.Canvas.getBody() as HTMLElement;

    const restoreFns = await this.prepareImagesForCapture(canvasBody);

    await new Promise(resolve => setTimeout(resolve, 100));

    try {
      const canvas = await html2canvas(canvasBody, {
        useCORS: true,
        allowTaint: false,
        backgroundColor: '#ffffff',
        scale: 1,
        windowWidth: canvasBody.scrollWidth,
        windowHeight: canvasBody.scrollHeight,
      });

      const thumbCanvas = document.createElement('canvas');
      const THUMB_WIDTH = 300;
      const ratio = THUMB_WIDTH / canvas.width;
      thumbCanvas.width = THUMB_WIDTH;
      thumbCanvas.height = canvas.height * ratio;

      const ctx = thumbCanvas.getContext('2d')!;
      ctx.drawImage(canvas, 0, 0, thumbCanvas.width, thumbCanvas.height);

      return thumbCanvas.toDataURL('image/jpeg', 0.8);
    } finally {
      restoreFns.forEach(restore => restore());
    }
  }

  private async prepareImagesForCapture(root: HTMLElement): Promise<Array<() => void>> {
    const imgs = Array.from(root.querySelectorAll('img'));
    const restoreFns: Array<() => void> = [];

    await Promise.all(
      imgs.map(img => {
        if (img.crossOrigin === 'anonymous') {
          restoreFns.push(() => {});
          return Promise.resolve();
        }

        const originalCrossOrigin = img.crossOrigin;
        const originalSrc = img.src;

        restoreFns.push(() => {
          img.onload = null;
          img.onerror = null;
          img.crossOrigin = originalCrossOrigin;
          img.src = originalSrc;
        });

        return new Promise<void>(resolve => {
          img.onload = () => resolve();
          img.onerror = () => resolve();
          img.crossOrigin = 'anonymous';
          img.src = originalSrc;
        });
      })
    );

    return restoreFns;
  }

  async saveTemplate() {

    if(this.previewSource == "upload" && !this.selectedFileName){
      this.toastrService.error("Please upload image preview.");
      return;
    }

    this.spinner.show();
    const inlineHtml = this.editor.runCommand("gjs-get-inlined-html");

    if(this.previewSource == "generate"){ // (Generate from template)
      const thumbnail = await this.generateThumbnail();
      this.thumbnailUrl = thumbnail;
    }

    const themeId = this.templateForm.get("themeId")?.value;
    let payload: any = {
      company_id: this.templateForm.get("company")?.value,
      template_name: this.templateForm.get("templateName")?.value,
      theme_ids: themeId,
      template_subject: this.templateForm.get("templateSubject")?.value,
      template_type: "email",
      template_html: inlineHtml,
      template_dataset_ui: "{}",
      isactive: true,
    };

    if(this.previewSource == "generate"){ // (Generate from template)
      payload["template_theme_image"] = this.thumbnailUrl
    }else if(this.previewSource == "upload"){ // (Custom Image)
      payload["template_image"] =  this.eb.fileBase64;
    }

    if (!this.editTemplateId) {
      this.eb.saveEmailTemplate(payload).subscribe({
        next: (res) => {
          this.spinner.hide();
          if (res.status) {
            this.toastrService.success(res.message);
          }
        },
        error: (err) => {
          this.spinner.hide();
          this.toastrService.error("Something went wrong while save template.");
        },
      });
    } else {
      this.eb.updateEmailTemplate(payload, this.editTemplateId).subscribe({
        next: (res) => {
          this.spinner.hide();
          if (res.status) {
            this.toastrService.success(res.message);
          }
        },
        error: (err) => {
          this.spinner.hide();
          this.toastrService.error(
            "Something went wrong while update template.",
          );
        },
      });
    }
  }
  onCompanyChangeGetJourney(companyId: number) {
    this.apiAssetsLoaded = false;
    if (companyId) {
      let self = this;
      this.spinner.show();
      this.clientService.getAllJourney(companyId).subscribe(
        (data) => {
          if (data.status) {
            // console.log("journeyTypeObj", data?.rows);
            self.journeyTypeObj = data?.rows;
            this.journeyTypeObj = this.journeyTypeObj.sort((a: any, b: any) => {
              return a.journey_name.localeCompare(b.journey_name);
            });
            // self.journeyTypeObj = data?.rows.map((item) => ({
            //   journey_id: item.journey_id,
            //   journey_name: item.journey_name,
            // }));
            // this.templateForm.patchValue({
            //   journeyType: self.journeyTypeObj[1]?.journey_name,
            // });
            this.companyID = companyId;

            this.spinner.hide();
          } else {
            self.journeyTypeObj = [];
            this.spinner.hide();
          }
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        },
      );
    } else {
      this.journeyTypeObj = [];
      this.spinner.hide();
    }
    // console.log("Selected Company ID:", this.journeyTypeObj);
  }

  async onJourneyTypeChangeGetTheme(journeyId: number): Promise<void> {
    this.spinner.show();

    return new Promise((resolve, reject) => {
      this.clientService
        .getAllThemeWithJourney(this.companyID, journeyId, this.domainID)
        .subscribe({
          next: (data) => {
            if (data?.status && data?.rows?.length) {
              // console.log("themeItems", data?.rows);

              this.themeItems = data?.rows;
              this.themeItems = this.themeItems.sort((a: any, b: any) => {
                return a.theme_name.localeCompare(b.theme_name);
              });
              // this.themeItems = data.rows.map((item) => ({
              //   theme_id: item.theme_id,
              //   theme_name: item.theme_name,
              // }));

              this.filteredThemeItems = [...this.themeItems];
            } else {
              this.themeItems = [];
              this.filteredThemeItems = [];
            }

            this.spinner.hide();
            resolve(); // ✅ VERY IMPORTANT
          },
          error: (error) => {
            console.error(error);
            this.themeItems = [];
            this.filteredThemeItems = [];
            this.spinner.hide();
            reject(error);
          },
        });
    });
  }

  loadImagesFromServer(page: number) {
    // reset file input
    const fileInput = document.getElementById('uploadInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }

    this.spinner.show();
    const companyID = this.templateForm.get("company")?.value;
    const search = this.imageSearchText;
    const domain = this.domainCurrentValue;
    this.eb.getEmailAllMedia(companyID, search, domain, this.limit, page).subscribe({
      next: (res) => {
        if (res.status) {
          this.totalAssets = res.data?.total;
          const assetManager = this.editor.AssetManager;
          assetManager.getAll().reset(); // optional: avoid duplicates

          res.data.rows.forEach((img: any) => {
            assetManager.add({
              src: `${img.media_url}?id=${img.id}`, // add unique query param to prevent deduplication by grapesjs
              type: img.media_type, //image
              name: img.media_name,
              id: img.id,
            });
          });
          this.renderAssetList();
          this.spinner.hide();
        } else {
          const assetManager = this.editor.AssetManager;
          assetManager.getAll().reset(); // optional: avoid duplicates
          this.totalAssets = 0;
          this.renderAssetList();
          this.spinner.hide();
        }
        this.updatePaginationButtons();
        this.renderNumberPagination();
      },
      error: (err) => {
        console.error("Load images failed", err);
        const assetManager = this.editor.AssetManager;
        assetManager.getAll().reset(); // optional: avoid duplicates
        this.totalAssets = 0;
        this.renderAssetList();
        this.updatePaginationButtons();
        this.renderNumberPagination();
        console.error("Load images failed", err, this.totalAssets, this.page, this.limit);
        this.spinner.hide();
        this.toastrService.error("Something went wrong while fetching image.");
      },
    });
  }

  deleteImageFromServer(imageID: number) {
    this.spinner.show();
    const companyID = this.templateForm.get("company")?.value;
    this.eb.deleteEmailMediaByID(companyID, imageID).subscribe({
      next: (res) => {
        if (res.status) {
          this.toastrService.success("Image deleted successfully.");
          this.loadImagesFromServer(this.page);
        }
        this.spinner.hide();
      },
      error: (err) => {
        this.spinner.hide();
        console.error("Delete failed", err);
        this.toastrService.error("Something went wrong while deleting image.");
      },
    });
  }

  private showConfirmPopup(message: string, onConfirm: () => void): void {
    document.querySelector(".custom-confirm-overlay")?.remove();

    const overlay = document.createElement("div");
    overlay.className = "custom-confirm-overlay";

    overlay.innerHTML = `
      <div class="custom-confirm-box">
        <p class="custom-confirm-message">${message}</p>
        <div class="custom-confirm-actions">
          <button class="custbtn custom-confirm-cancel">Cancel</button>
          <button class="custbtn custom-confirm-delete">Delete</button>
        </div>
      </div>
    `;

    document.body.appendChild(overlay);

    const cleanup = () => overlay.remove();

    overlay
      .querySelector(".custom-confirm-cancel")
      ?.addEventListener("click", cleanup);

    overlay
      .querySelector(".custom-confirm-delete")
      ?.addEventListener("click", () => {
        cleanup();
        onConfirm();
      });

    // Optional: close on backdrop click
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) cleanup();
    });
  }

  async uploadImagesToServer(files: FileList, editor: any) {
    this.spinner.show();
    const mediaItems = await Promise.all(
      Array.from(files).map((file) => this.buildMediaPayload(file)),
    );

    const companyID = this.templateForm.get("company")?.value;

    const finalPayload = {
      domain_id: this.domainCurrentValue != "null" ? Number(this.domainCurrentValue) : this.emailTemplateThemeCategoryId,
      is_corporate: true,
      user_ds_id: 0,
      company_id: companyID,
      isactive: true,
      media_types: mediaItems.map((item) => item.media_type),
      media_names: mediaItems.map((item) => item.media_name),
      media_filetypes: mediaItems.map((item) => item.media_filetype),
      media_files: mediaItems.map((item) => item.media_file),
    };

    this.eb.postEmailMedia(finalPayload).subscribe({
      next: (res) => {
        if (res.status) {
          this.toastrService.success(res.message);
          this.loadImagesFromServer(this.page);
        } else {
          this.spinner.hide();
          this.toastrService.error("Failed to upload images.");
        }
      },
      error: (err) => {
        console.error("Upload failed", err);
        this.spinner.hide();
        this.toastrService.error("Something went wrong while upload image.");
      },
    });
  }

  async buildMediaPayload(file: File) {
    const base64 = await this.fileToBase64(file);
    return {
      media_name: file.name,
      media_type: file.type.split("/")[0],
      media_filetype: file.name.split(".").pop(),
      media_file: base64,
    };
  }

  fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file); // IMPORTANT
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  }

  backToTemplateList() {
    this.router.navigate(["/corporate/cb-email-templates"]);
  }

  registerMergeTagRTE() {
    const editor = this.editor;
    const self = this;

    editor.RichTextEditor.add("merge-tags", {
      icon: `<span style="font-size:13px;font-weight:600;">[[]]</span>`,
      attributes: { title: "Insert Personalization" },
      result: function (rte: any) {
        self.openMergeTagModal(rte);
      },
    });
  }

  initPersonalizedFields() {
    this.spinner.show();
    const companyID = this.templateForm.get("company")?.value;
    this.eb.getPersonalizationList(companyID).subscribe({
      next: (res) => {
        if (res.status) {
          this.personalizationData = res.data;
        }
        this.spinner.hide();
      },
      error: (err) => {
        this.spinner.hide();
        this.toastrService.error(
          "Something went wrong while fetching Personalized Fields.",
        );
      },
    });
  }

  openMergeTagModal(rte: any) {
    const editor = this.editor;
    const data = this.personalizationData;
    const targetEl = rte.el;
    const win = editor.Canvas.getWindow();
    const sel = win.getSelection();

    // 1. Capture the range precisely before opening the modal
    this.savedRange = null;
    if (sel.rangeCount > 0) {
      this.savedRange = sel.getRangeAt(0).cloneRange();
    }

    let html = `
      <div class="personalized-field-modal">
        <input type="text" id="merge-search" placeholder="Search..." class="personalized-field-input-search"/>
    `;

    Object.entries(data).forEach(([category, items]: [string, any[]]) => {
      html += `<div class="merge-category-container">
                <div class="merge-category-item" style="font-weight:bold; margin-top:10px;">${category}</div>
                <div class="merge-item-container">`;
      items.forEach((val: any) => {
        const key = val.personalization_key;
        html += `<div class="merge-item" data-key="${key}" style="cursor:pointer; padding:5px; border:1px solid #ccc; margin:2px; display:inline-block;">[[${key}]]</div>`;
      });
      html += `</div></div>`;
    });
    html += `</div>`;

    editor.Modal.setTitle("Insert Personalization Field");
    editor.Modal.setContent(html);
    editor.Modal.open();

    setTimeout(() => {
      const items = document.querySelectorAll(".merge-item");
      items.forEach((el: any) => {
        el.addEventListener("click", () => {
          const key = el.getAttribute("data-key");
          if (!key) return;

          const tag = `[[${key}]]`;

          targetEl.focus();

          if (this.savedRange) {
            const textNode = win.document.createTextNode(tag);

            this.savedRange.deleteContents();

            this.savedRange.insertNode(textNode);

            this.savedRange.setStartAfter(textNode);
            this.savedRange.setEndAfter(textNode);

            const selected = editor.getSelected();
            if (selected) {
              selected.set("content", selected.get("content"));
            }
          } else {
            editor.insertContent(tag);
          }

          editor.Modal.close();
        });
      });

      // Search logic
      const searchInput: any = document.getElementById("merge-search");
      if (searchInput) {
        searchInput.addEventListener("keyup", (event: any) => {
          const value = (event.target as HTMLInputElement).value.toLowerCase();

          document.querySelectorAll(".merge-item").forEach((item: any) => {
            const text = item.innerText.toLowerCase();
            item.style.display = text.includes(value) ? "block" : "none";
          });
        });
      }
    }, 0);
  }

  OpenAddThemeModal(modalName: any) {
    this.modalRef = this.modalService.open(modalName);

    this.modalRef.result.then(
      (result) => {},
      (reason) => {},
    );
  }

  onModalThemeAdd() {
    const journeyId = this.templateForm.get("journeyType")?.value;
    this.onJourneyTypeChangeGetTheme(journeyId);
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (!file) return;

    // ✅ Validate image type
    if (!file.type.startsWith("image/")) {
      this.toastrService.error("Only image files are allowed.");
      this.removeFile();
      return;
    }
    this.selectedFile = file;
    this.selectedFileName = file.name;
    const reader = new FileReader();
    reader.onload = () => {
      this.imagePreview = reader.result as string;
    };
    reader.readAsDataURL(file);

    this.previewSource = 'upload';
    this.popoverOpen = false;
    this.convertToBase64(file);
  }

  convertToBase64(file: File) {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => {
      const base64 = reader.result as string;
      this.imagePreview = base64;
      this.eb.setFile(base64, file.name);
    };

    reader.onerror = (error) => {
      console.error("Error converting file:", error);
    };
  }

  async convertUrlToBase64(url: string | null, fileName: string): Promise<void> {
    if (!url) {
      console.error("No URL provided for conversion");
      return;
    }
    
    try {
      const response = await fetch(url);
      const blob = await response.blob();

      const base64 = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
          resolve(reader.result as string);
        };

        reader.onerror = (error) => {
          reject(error);
        };

        reader.readAsDataURL(blob);
      });

      this.imagePreview = base64;
      this.eb.setFile(base64, fileName);
    } catch (error) {
      console.error("Error converting file:", error);
    }
  }

  removeFile() {
    this.selectedFileName = null;
    this.imagePreview = null;
    this.eb.clearFile();
  }

  getFileNameFromUrl(url: string | null | undefined): string {
    if (!url) return "";

    try {
      // Remove query params and hash
      const cleanUrl = url.split("?")[0].split("#")[0];
      // Extract filename
      const fileName = cleanUrl.substring(cleanUrl.lastIndexOf("/") + 1);
      // Decode URL encoding (%20 -> space)
      return decodeURIComponent(fileName);
    } catch (error) {
      console.error("Invalid URL:", error);
      return "";
    }
  }

  loadHtmlEditor() {
    this.editor.Commands.add("open-editable-code", {
      run: (editor: any) => {
        const inlineHtml = this.editor.runCommand("gjs-get-inlined-html");        
        const wrapper = document.createElement("div");
        Object.assign(wrapper.style, {
          padding: "12px",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        });

        wrapper.innerHTML = `
          <label><b>HTML</b></label>
          <textarea id="gjs-html" style="width:100%;height:200px;font-family:monospace;padding:8px;">
            ${inlineHtml}
          </textarea>

          <div style="display:flex;justify-content:flex-end;gap:10px;">
            <button id="gjs-cancel" class="gjs-btn-prim">Cancel</button>
            <button id="gjs-save" class="gjs-btn-prim">Apply Changes</button>
          </div>
        `;

        editor.Modal.open({
          title: "Edit HTML & CSS",
          content: wrapper,
        });

        // Button events
        wrapper.querySelector("#gjs-cancel")?.addEventListener("click", () => {
          editor.Modal.close();
        });

        wrapper.querySelector("#gjs-save")?.addEventListener("click", () => {
          const html = (
            wrapper.querySelector("#gjs-html") as HTMLTextAreaElement
          ).value;

          editor.DomComponents.clear();
          editor.setComponents(html);

          editor.Modal.close();
        });
      },
    });
  }

  openMargoAITemplateCreationModel() {
    this.editor.Commands.add("open-ai-agent", {
      run: (editor: any) => {
        const wrapper = document.createElement('div');
        Object.assign(wrapper.style, {
          padding: '12px',
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
        });

        wrapper.innerHTML = `
          <!-- STEP 1: Prompt input -->
          <div class="input-dock" id="step1">
            <div class="back-list-link">
              <span class="back-link" id="backToListLink" style="display:none;">
                <i class="fa fa-arrow-left"></i> Back to suggested templates
              </span>
            </div>
            <div class="prompt-snippets-wrapper" id="promptSnippetsWrapper">
              <span class="prompt-snippet-toggle" id="promptSnippetToggle">
                <i class="fa fa-magic"></i> Prompt Snippets
                <i class="fa fa-chevron-down toggle-arrow" id="toggleArrow"></i>
              </span>

              <div class="prompt-snippet-panel" id="promptSnippetPanel">
                <div class="prompt-snippet-loading" id="promptSnippetLoading" style="display:none;">
                  <i class="fa fa-spinner fa-spin"></i> Loading...
                </div>
                <div class="prompt-snippet-empty" id="promptSnippetEmpty" style="display:none;">
                  No prompt snippets found.
                </div>
                <div class="prompt-snippet-scroll" id="promptSnippetScroll">
                  <div class="prompt-snippet-chips" id="promptSnippetList"></div>
                  <div class="prompt-snippet-loading-more" id="promptSnippetLoadingMore" style="display:none;">
                    <i class="fa fa-spinner fa-spin"></i> Loading more...
                  </div>
                </div>
              </div>
            </div>
            <div class="input-box" id="inputBox">
              <textarea
                id="chatInput"
                class="chat-input"
                placeholder="Describe the template you need…"
                rows="1"
              ></textarea>
              <button class="send-btn" id="sendBtn" title="Search (Enter)" disabled>
                <i class="fa fa-paper-plane-o" aria-hidden="true"></i>
              </button>
            </div>
            <p class="input-hint">
              Press <kbd>Enter</kbd> to search &nbsp;·&nbsp; <kbd>Shift + Enter</kbd> for new line
            </p>
          </div>

          <!-- Loading -->
          <div class="suggestion-loading" id="loadingState" style="display:none;">
            <i class="fa fa-spinner fa-spin"></i> Finding matching templates…
          </div>

          <!-- STEP 2: Suggestions -->
          <div class="suggested-templates" id="step2" style="display:none;">
            <div class="suggestions-header">
              <label class="suggestions-label" id="suggestionsLabel">Suggested Templates</label>
              <div class="header-actions">
                <span class="back-link" id="editPromptLink">
                  <i class="fa fa-arrow-left"></i> Edit prompt
                </span>
              </div>
            </div>

            <div class="empty-suggestions" id="emptyState" style="display:none;">
              <i class="fa fa-inbox empty-icon"></i>
              <p>No existing templates match your prompt.</p>
              <button class="btn-create-new" id="createNewEmptyBtn">
                <i class="fa fa-plus"></i> Create New Template
              </button>
            </div>

            <div class="template-grid ai-agent-scroll" id="templateList"></div>
          </div>

          <div style="display:flex;justify-content:flex-end;gap:10px;margin-top:8px;">
            <button id="gjs-close" class="gjs-btn-prim">Close</button>
          </div>
        `;

        editor.Modal.open({
          title: "marGo AI Agent",
          content: wrapper,
        });

        // ---- element refs ----
        const step1 = wrapper.querySelector('#step1') as HTMLElement;
        const step2 = wrapper.querySelector('#step2') as HTMLElement;
        const loadingState = wrapper.querySelector('#loadingState') as HTMLElement;
        const inputBox = wrapper.querySelector('#inputBox') as HTMLElement;
        const chatInput = wrapper.querySelector('#chatInput') as HTMLTextAreaElement;
        const sendBtn = wrapper.querySelector('#sendBtn') as HTMLButtonElement;
        const backToListLink = wrapper.querySelector('#backToListLink') as HTMLElement;
        const editPromptLink = wrapper.querySelector('#editPromptLink') as HTMLElement;
        const suggestionsLabel = wrapper.querySelector('#suggestionsLabel') as HTMLElement;
        const emptyState = wrapper.querySelector('#emptyState') as HTMLElement;
        const createNewEmptyBtn = wrapper.querySelector('#createNewEmptyBtn') as HTMLElement;
        const templateList = wrapper.querySelector('#templateList') as HTMLElement;
        const promptSnippetToggle = wrapper.querySelector('#promptSnippetToggle') as HTMLElement;
        const promptSnippetLoading = wrapper.querySelector('#promptSnippetLoading') as HTMLElement;
        const promptSnippetEmpty = wrapper.querySelector('#promptSnippetEmpty') as HTMLElement;
        const promptSnippetList = wrapper.querySelector('#promptSnippetList') as HTMLElement;
        const promptSnippetPanel = wrapper.querySelector('#promptSnippetPanel') as HTMLElement;
        const promptSnippetLoadingMore = wrapper.querySelector('#promptSnippetLoadingMore') as HTMLElement;
        const promptSnippetScroll = wrapper.querySelector('#promptSnippetScroll') as HTMLElement;
        
        // ---- render helpers ----
        const renderStep1 = () => {
          step1.style.display = 'block';
          loadingState.style.display = 'none';
          step2.style.display = 'none';
          backToListLink.style.display = this.aiSuggestedTemplates.length > 0 ? 'inline-block' : 'none';
        };

        const renderLoading = () => {
          step1.style.display = 'none';
          loadingState.style.display = 'block';
          step2.style.display = 'none';
        };

        const renderTemplateList = () => {
          templateList.innerHTML = '';
          this.aiSuggestedTemplates.forEach((tpl: any) => {
            const card = document.createElement('div');
            card.className = 'template-card';
            card.innerHTML = `
              <div class="template-thumb">
                <iframe sandbox="allow-same-origin" tabindex="-1"></iframe>
                <div class="template-thumb-overlay">
                  <button class="template-preview-btn">
                    <i class="fa fa-eye"></i> Preview
                  </button>
                </div>
              </div>
              <div class="template-card-footer">
                <span class="template-name" title="${tpl.subject}">${tpl.subject}</span>
                <button class="btn-use">Use</button>
              </div>
            `;

            const iframe = card.querySelector('iframe') as HTMLIFrameElement;
            iframe.srcdoc = tpl.html_template || '';

            card.querySelector('.template-preview-btn')?.addEventListener('click', () => viewTemplate(tpl));
            card.querySelector('.btn-use')?.addEventListener('click', () => useTemplate(tpl));

            templateList.appendChild(card);
          });

          const addNewCard = document.createElement('div');
          addNewCard.className = 'template-card add-new-card';
          addNewCard.innerHTML = `<i class="fa fa-plus" style="font-size:20px;"></i><span>Create New Template</span>`;
          addNewCard.addEventListener('click', () => createNewWithAI());
          templateList.appendChild(addNewCard);
        };

        const renderStep2 = () => {
          step1.style.display = 'none';
          loadingState.style.display = 'none';
          step2.style.display = 'block';

          suggestionsLabel.textContent =
            this.aiSuggestedTemplates.length > 0 ? 'Suggested Templates' : 'No Matching Templates';

          if (this.aiSuggestedTemplates.length === 0) {
            emptyState.style.display = 'flex';
            templateList.style.display = 'none';
            templateList.innerHTML = '';
          } else {
            emptyState.style.display = 'none';
            templateList.style.display = 'grid';
            renderTemplateList();
          }
        };

        const resetAiAgentState = () => {
          this.aiInputValue = '';
          this.aiIsStreaming = false;
          this.aiIsFetchingSuggestions = false;
          this.aiSuggestedTemplates = [];
          this.aiLastPrompt = '';
        };

        const fetchSuggestedTemplates = async () => {
          if (!this.aiInputValue.trim()) return;

          this.aiLastPrompt = this.aiInputValue.trim();
          this.aiIsFetchingSuggestions = true;
          renderLoading();

          try {
            const res = await this.eb.getSuggestedTemplates(this.companyID, this.aiLastPrompt).toPromise();
            this.aiSuggestedTemplates = res?.data || [];
          } catch (err) {
            console.error('Error fetching suggested templates', err);
            this.aiSuggestedTemplates = [];
          } finally {
            this.aiIsFetchingSuggestions = false;
            renderStep2();
          }
        };

        const resetToPrompt = () => renderStep1();
        const backToList = () => renderStep2();

        const viewTemplate = (tpl: any) => {
          const previewWrapper = document.createElement('div');
          Object.assign(previewWrapper.style, { display: 'flex', flexDirection: 'column', gap: '10px' });

          previewWrapper.innerHTML = `
            <div style="border:1px solid #ddd; border-radius:4px; overflow:hidden;">
              <iframe
                id="templatePreviewFrame"
                style="width:100%; height:500px; border:none; display:block;"
                sandbox="allow-same-origin"
              ></iframe>
            </div>
            <div style="display:flex; justify-content:flex-end; gap:10px;">
              <button id="useFromPreviewBtn" class="gjs-btn-prim">Use this template</button>
              <button id="closePreviewBtn" class="gjs-btn-prim">Back</button>
            </div>
          `;

          editor.Modal.open({ title: tpl.subject || 'Template Preview', content: previewWrapper });

          const iframe = previewWrapper.querySelector('#templatePreviewFrame') as HTMLIFrameElement;
          iframe.srcdoc = tpl.html_template || '';

          previewWrapper.querySelector('#useFromPreviewBtn')?.addEventListener('click', () => useTemplate(tpl));
          previewWrapper.querySelector('#closePreviewBtn')?.addEventListener('click', () => {
            editor.Modal.open({ title: "marGo AI Agent", content: wrapper });
          });
        };

        const useTemplate = (tpl: any) => {
          editor.DomComponents.clear();
          editor.setComponents(tpl.html_template);
          resetAiAgentState();
          editor.Modal.close();
        };
        const appendPromptSnippetChips = (items: any[], startIndex: number) => {
          items.forEach((item: any, i: number) => {
            const chip = document.createElement('div');
            chip.className = 'prompt-snippet-chip';
            chip.style.animationDelay = `${(startIndex + i) * 30}ms`;
            chip.textContent = item.prompt;
            chip.title = item.prompt;
            chip.addEventListener('click', () => {
              this.aiInputValue = item.prompt;
              chatInput.value = item.prompt;
              inputBox.classList.add('focused');
              updateSendBtn();
              chatInput.style.height = 'auto';
              chatInput.style.height = chatInput.scrollHeight + 'px';
              chatInput.focus();
              closePromptPanel();
            });
            promptSnippetList.appendChild(chip);
          });
        };

        const renderPromptSnippetList = () => {
          promptSnippetList.innerHTML = '';
          appendPromptSnippetChips(this.promptSnippetsData, 0);
        };

        const fetchPromptSnippets = (loadMore: boolean = false) => {
          if (this.promptSnippetsLoadingMore) return;

          if (!loadMore) {
            this.promptSnippetsPage = 1;
            this.promptSnippetsData = [];
            promptSnippetLoading.style.display = 'block';
            promptSnippetEmpty.style.display = 'none';
            promptSnippetList.style.display = 'none';
          } else {
            this.promptSnippetsLoadingMore = true;
            promptSnippetLoadingMore.style.display = 'block';
          }

          const skip = (this.promptSnippetsPage - 1) * this.promptSnippetsLimit;

          this.campaignBuilderService.getPromptRecords(this.companyID, this.promptSnippetsLimit, skip, true).subscribe(
            (res: any) => {
              promptSnippetLoading.style.display = 'none';
              promptSnippetLoadingMore.style.display = 'none';
              this.promptSnippetsFetched = true;
              this.promptSnippetsLoadingMore = false;

              const rows = res?.data?.rows || [];
              this.promptSnippetsTotal = res?.data?.total || 0;

              if (res?.status && rows.length) {
                const startIndex = this.promptSnippetsData.length;
                this.promptSnippetsData = [...this.promptSnippetsData, ...rows];
                promptSnippetList.style.display = 'flex';
                promptSnippetEmpty.style.display = 'none';
                appendPromptSnippetChips(rows, startIndex);
              } else if (!loadMore) {
                this.promptSnippetsData = [];
                promptSnippetEmpty.style.display = 'block';
              }

              setPanelHeight();
            },
            (err: any) => {
              console.error('Error fetching prompt snippets', err);
              promptSnippetLoading.style.display = 'none';
              promptSnippetLoadingMore.style.display = 'none';
              this.promptSnippetsFetched = true;
              this.promptSnippetsLoadingMore = false;
              if (!loadMore) promptSnippetEmpty.style.display = 'block';
            }
          );
        };

        promptSnippetScroll.addEventListener('scroll', () => {
          if (this.promptSnippetsLoadingMore) return;
          if (this.promptSnippetsData.length >= this.promptSnippetsTotal) return;

          const { scrollTop, scrollHeight, clientHeight } = promptSnippetScroll;
          if (scrollHeight - (scrollTop + clientHeight) < 40) {
            this.promptSnippetsPage += 1;
            fetchPromptSnippets(true);
          }
        });

        promptSnippetToggle.addEventListener('click', () => {
          const isOpen = promptSnippetPanel.classList.contains('open');
          if (isOpen) {
            promptSnippetPanel.classList.remove('open');
            promptSnippetToggle.classList.remove('active');
            return;
          }
          promptSnippetPanel.classList.add('open');
          promptSnippetToggle.classList.add('active');

          if (this.promptSnippetsFetched) {
            if (this.promptSnippetsData.length) {
              promptSnippetEmpty.style.display = 'none';
              promptSnippetList.style.display = 'flex';
              renderPromptSnippetList();
            } else {
              promptSnippetList.style.display = 'none';
              promptSnippetEmpty.style.display = 'block';
            }
          } else {
            fetchPromptSnippets();
          }
        });

        const MAX_PANEL_HEIGHT = 260;

        const setPanelHeight = () => {
          if (!promptSnippetPanel.classList.contains('open')) return;
          promptSnippetPanel.style.maxHeight = Math.min(promptSnippetPanel.scrollHeight, MAX_PANEL_HEIGHT) + 'px';
        };

      const closePromptPanel = () => {
        // current height ko explicitly lock karo pehle, tabhi transition ko proper starting point milega
        promptSnippetPanel.style.maxHeight = promptSnippetPanel.scrollHeight + 'px';
        // forced reflow — browser ko upar wali value "register" karwane ke liye zaroori hai
        void promptSnippetPanel.offsetHeight;

        promptSnippetPanel.classList.remove('open');
        promptSnippetToggle.classList.remove('active');

          //         if (isOpen) {
          //   promptSnippetPanel.classList.remove('open');
          //   promptSnippetToggle.classList.remove('active');
          //   return;
          // }
      };

        const resetPromptSnippetsCache = () => {
          this.promptSnippetsData = [];
          this.promptSnippetsFetched = false;
          this.promptSnippetsPage = 1;
          this.promptSnippetsTotal = 0;
          this.promptSnippetsLoadingMore = false;
        };
        const createNewWithAI = async () => {
          if (!this.aiLastPrompt.trim()) return;

          this.aiIsStreaming = true;
          this.spinner.show();

          try {
            const payload = { message: this.aiLastPrompt };
            const result = await this.eb.createAiTemplate(payload, this.companyID).toPromise();
            const data = result.data[0].output;

            editor.DomComponents.clear();
            editor.setComponents(data.html_template);
            resetAiAgentState();
            editor.Modal.close();
            resetPromptSnippetsCache();
          } catch (err) {
            console.error('Error creating template via AI', err);
          } finally {
            this.aiIsStreaming = false;
            this.spinner.hide();
          }
        };

        const updateSendBtn = () => {
          sendBtn.disabled = !this.aiInputValue.trim() || this.aiIsStreaming;
        };

        chatInput.addEventListener('input', (e) => {
          this.aiInputValue = (e.target as HTMLTextAreaElement).value;
          inputBox.classList.toggle('focused', this.aiInputValue.length > 0);
          updateSendBtn();
          chatInput.style.height = 'auto';
          chatInput.style.height = chatInput.scrollHeight + 'px';
        });

        chatInput.addEventListener('keydown', (e: KeyboardEvent) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (!sendBtn.disabled) fetchSuggestedTemplates();
          }
        });

        sendBtn.addEventListener('click', () => fetchSuggestedTemplates());
        editPromptLink.addEventListener('click', () => resetToPrompt());
        backToListLink.addEventListener('click', () => backToList());
        createNewEmptyBtn.addEventListener('click', () => createNewWithAI());
        wrapper.querySelector('#gjs-close')?.addEventListener('click', () => {
          editor.Modal.close(); 
          resetToPrompt();
          resetPromptSnippetsCache();
        });

        // ---- restore previous state on reopen ----
        chatInput.value = this.aiInputValue;
        inputBox.classList.toggle('focused', this.aiInputValue.length > 0);
        updateSendBtn();
        if (chatInput.value) {
          chatInput.style.height = 'auto';
          chatInput.style.height = chatInput.scrollHeight + 'px';
        }

        if (this.aiSuggestedTemplates.length > 0) {
          renderStep2();
        } else {
          renderStep1();
        }
      },
    });
  }


  // ---- Getters ----
  get activePreviewUrl(): string | null {
    if (this.previewSource === 'theme') {
      return this.selectedThemeImageUrl;
    }
    if (this.previewSource === 'upload') {
      return this.imagePreview;
    }
    // generate
    return this.generatedPreviewUrl;
  }

  get previewSourceLabel(): string {
    if (this.previewSource === 'theme') {
      return this.selectedThemeName || 'Theme image';
    }
    if (this.previewSource === 'upload') {
      return this.selectedFileName || 'Choose file';
    }
    // generate
    return this.generatedPreviewUrl ? 'Generated preview' : 'Auto-generate';
  }

  togglePreviewPopover(event: Event) {
    event.stopPropagation();
    this.popoverOpen = !this.popoverOpen;
  }

  setPreviewSource(source: PreviewSource) {
    this.previewSource = source;
    if (source !== 'upload') {
      this.popoverOpen = false;
    }
  }
  
}
